import { getAuthHeader } from "@src/app/superagent";
import { environmentConfig } from "@src/appV2/environment";
import { logApiFailureEvent } from "@src/lib/analytics";
import { Shift } from "@src/lib/interface";
import { DateRange } from "@src/lib/utils";
import request from "superagent";

import { ShiftDateMap } from "./model";

export interface FetchYourShiftsParams {
  dateFilter: DateRange;
  groupByDate?: boolean;
}
export interface FetchAgentUnverifiedShifts {
  bffShiftsRouteProbability: number;
}

interface FetchYourShiftsParamsDateAggregated extends FetchYourShiftsParams {
  groupByDate: true;
}

type FetchYourShiftsResponse<T extends FetchYourShiftsParams> =
  T extends FetchYourShiftsParamsDateAggregated ? ShiftDateMap : Array<Required<Shift>>;

const GET_AGENT_SHIFTS_URL_V1 = `${environmentConfig.REACT_APP_BFF_URL}/calendar/agent`;

export const fetchYourShifts = async <T extends FetchYourShiftsParams>({
  dateFilter,
  groupByDate = false,
}: T): Promise<FetchYourShiftsResponse<T>> => {
  return request
    .get(GET_AGENT_SHIFTS_URL_V1)
    .retry(1, (err) => {
      if (!err) {
        return false;
      }
      return true;
    })
    .set(await getAuthHeader())
    .query({ dateFilter, groupByDate })
    .then(({ body }) => {
      return body.agentShifts;
    })
    .catch((error) => {
      logApiFailureEvent(error);
      throw error;
    });
};
